import { IonButton, IonContent, IonPage, IonToast } from "@ionic/react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import AdminGoogleButton from "../components/AdminGoogleButton.jsx";
import AuthDivider from "../components/AuthDivider.jsx";
import { useAuth } from "../auth/AuthContext.jsx";

export default function LoginPage() {
  const { loginWithGoogleCredential } = useAuth();
  const history = useHistory();
  const [error, setError] = useState("");
  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || "";
  const isGoogleConfigured = googleClientId && !googleClientId.includes("local-google-client-id") && !googleClientId.includes("missing");

  async function handleGoogle(response) {
    try {
      await loginWithGoogleCredential(response);
      history.replace("/app/schedule");
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <IonPage>
      <IonContent fullscreen className="auth-screen">
        <div className="auth-card auth-card-compact auth-card-home">
          <img className="auth-logo auth-logo-home" src="/branding/metora-logo.png" alt="Metora logo" />
          <div className="auth-home-copy">
            <h1>Metora</h1>
            <p>Schedule. Track. Invoice.</p>
          </div>
          <div className="auth-actions">
            <IonButton expand="block" onClick={() => history.push("/login/create")}>Create Admin Account</IonButton>
            <IonButton expand="block" fill="outline" onClick={() => history.push("/login/sign-in")}>Sign In</IonButton>
          </div>
          <AuthDivider />
          <AdminGoogleButton
            isConfigured={isGoogleConfigured}
            onSuccess={handleGoogle}
            onError={() => setError("Google login failed")}
          />
          <IonButton expand="block" fill="clear" className="auth-link-button auth-link-button-strong" onClick={() => history.push("/join")}>
            Already have a team? Join Team
          </IonButton>
        </div>
        <IonToast isOpen={Boolean(error)} message={error} duration={2500} onDidDismiss={() => setError("")} />
      </IonContent>
    </IonPage>
  );
}
